module.exports = __webpack_public_path__ + "img/icone-faturamento.1fc0ea6b.svg";